import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import LeftArrowIcon from '../components/icons/LeftArrowIcon';

const Profile: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleNavigateToRoleProfile = () => {
    if (currentUser?.role === 'student') {
      navigate('/class/student/profile');
    } else if (currentUser?.role === 'teacher' || currentUser?.role === 'schoolAdmin' || currentUser?.role === 'superAdmin') {
      navigate('/class/teacher/profile');
    }
  };

  const roleLabel = currentUser?.role === 'student' ? '학생' :
    currentUser?.role === 'teacher' ? '교사' :
    currentUser?.role === 'schoolAdmin' ? '학교 관리자' :
    currentUser?.role === 'superAdmin' ? '시스템 관리자' : '사용자';

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--Color-background-main, #f5f5f5)' }}>
      <div style={{
        backgroundColor: 'var(--Color-fill-brand-color, #FF6F0F)',
        color: 'white',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
      }}>
        <button type="button" onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 4 }}>
          <LeftArrowIcon width={24} height={24} />
        </button>
        <h1 style={{ margin: 0, fontSize: 18, flex: 1 }}>내 프로필</h1>
      </div>

      <div style={{ maxWidth: 960, margin: '0 auto', padding: 24 }}>
        <h2 style={{ marginBottom: 24, fontSize: 24 }}>내 프로필</h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <Card padding="24px" style={{ textAlign: 'center' }}>
            <div style={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              margin: '0 auto 16px',
              background: '#e0e0e0',
              fontSize: 48,
              lineHeight: '120px',
              textAlign: 'center',
              overflow: 'hidden',
            }}>
              {currentUser?.photoURL ? (
                <img src={currentUser.photoURL} alt={currentUser?.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <span>{currentUser?.name?.[0] || '?'}</span>
              )}
            </div>
            <h3 style={{ margin: '0 0 8px', fontSize: 20 }}>{currentUser?.name}</h3>
            <p style={{ margin: '0 0 8px', color: '#666' }}>{currentUser?.email}</p>
            <span style={{
              display: 'inline-block',
              marginTop: 8,
              padding: '4px 12px',
              borderRadius: 16,
              border: '1px solid var(--Color-fill-brand-color)',
              color: 'var(--Color-fill-brand-color)',
              fontSize: 14,
            }}>
              {roleLabel}
            </span>
          </Card>

          <Card padding="24px">
            <h3 style={{ margin: '0 0 16px', fontSize: 18 }}>기본 정보</h3>
            <hr style={{ border: 'none', borderTop: '1px solid #eee', marginBottom: 16 }} />
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
              <div style={{ flex: '1 1 200px' }}>
                <p style={{ margin: '0 0 4px', fontSize: 12, color: '#666' }}>이메일</p>
                <p style={{ margin: 0 }}>{currentUser?.email || '정보 없음'}</p>
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <p style={{ margin: '0 0 4px', fontSize: 12, color: '#666' }}>역할</p>
                <p style={{ margin: 0 }}>{roleLabel}</p>
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <p style={{ margin: '0 0 4px', fontSize: 12, color: '#666' }}>계정 상태</p>
                <p style={{ margin: 0 }}>{currentUser?.isActive ? '활성' : '비활성'}</p>
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <p style={{ margin: '0 0 4px', fontSize: 12, color: '#666' }}>로그인 방식</p>
                <p style={{ margin: 0 }}>{currentUser?.loginType || 'local'}</p>
              </div>
            </div>
            {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'schoolAdmin' || currentUser?.role === 'superAdmin') && (
              <div style={{ marginTop: 24 }}>
                <Button variant="primary" onClick={handleNavigateToRoleProfile} style={{ width: '100%' }}>
                  상세 프로필 보기
                </Button>
              </div>
            )}
          </Card>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 16 }}>
              <Card padding="16px" style={{ textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: 24, fontWeight: 700, color: 'var(--Color-fill-brand-color)' }}>{currentUser?.role || '?'}</p>
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#666' }}>사용자 역할</p>
              </Card>
              <Card padding="16px" style={{ textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>{currentUser?.isActive ? '활성' : '비활성'}</p>
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#666' }}>계정 상태</p>
              </Card>
              <Card padding="16px" style={{ textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>{currentUser?.loginType || 'local'}</p>
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#666' }}>로그인 방식</p>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
